module.exports = __webpack_public_path__ + "img/FILOSOFIA.76f88584.png";